import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap';
import { AddEditUserActionsModalComponent } from './add-edit-user-actions-modal.component';
import { SubordinatesInBuModule } from '../subordinates-in-bu/subordinates-in-bu.module';

@NgModule({
  declarations: [AddEditUserActionsModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    SubordinatesInBuModule
  ],
  exports: [AddEditUserActionsModalComponent],
  entryComponents: [AddEditUserActionsModalComponent]
})
export class AddEditUserActionsModalModule { }
